import React, { FC } from 'react';
import { Box, Link, Typography } from '@mui/material';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';

import { UserFeedFollowGroupFragment } from 'api';
import { Numeric } from 'components';
import { generateLink } from 'Links';
import theme from 'theme';

interface Props {
  group: UserFeedFollowGroupFragment;
}

const styles = {
  number: {
    color: theme.palette.grey[600],
  },
  icon: {
    color: theme.palette.grey[400],
  },
} as const;

const MembersCell: FC<Props> = ({ group }) => (
  <Typography variant="h6" fontWeight={theme.typography.fontWeightRegular}>
    <Link
      component={generateLink(`/group/${group.id}/members`)}
      underline="hover"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      <Numeric value={group.follower_count} sx={styles.number} />
      <Box marginLeft={1} display="flex" alignItems="center">
        <PeopleAltRoundedIcon sx={styles.icon} />
      </Box>
    </Link>
  </Typography>
);

export default MembersCell;
